import Card from '../Card'
import { createUseStyles } from 'react-jss'
import { Colors } from '../../constants/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBan } from '@fortawesome/free-solid-svg-icons'
import { IntegrationSigningCredentialModel } from '../../redux/types'
import { formatDateTimeString } from '../../utils/dateHelper'

interface Props {
  credentials: IntegrationSigningCredentialModel[]
  onRevokeClick?: (credential: IntegrationSigningCredentialModel) => void
}

const IntegrationSigningCredentialList = ({ credentials, onRevokeClick }: Props) => {
  const styles = useStyles()

  const renderHeader = () => {
    return (
      <Card className={`${styles.container} ${styles.header} card`}>
        <div className={styles.thumbprintCell}>
          <p><span>Id</span></p>
        </div>
        <div className={styles.thumbprintCell}>
          <p><span>Thumbprint</span></p>
        </div>
        <div className={styles.cell}>
          <p><span>Active from</span></p>
        </div>
        <div className={styles.cell}>
          <p><span>Expires at</span></p>
        </div>
        <div className={styles.cell}>
          <p><span>Revoked at</span></p>
        </div>
        <div className={`${styles.cell} ${styles.actionCell}`}>
        </div>
      </Card>
    )
  }

  const renderListItems = () => {
    return credentials.map((item) => {
      const revoked = item.revokedAt != null
      return (
        <Card className={`${styles.container} card`} key={`credential_${item.id}`}>
          <div className={styles.thumbprintCell}>
            <p>{item.id}</p>
          </div>
          <div className={styles.thumbprintCell}>
            <p>{item.thumbprint}</p>
          </div>
          <div className={styles.cell}>
            <p>{formatDateTimeString(item.activeFrom)}</p>
          </div>
          <div className={styles.cell}>
            <p>{formatDateTimeString(item.expiresAt)}</p>
          </div>
          <div className={styles.cell}>
            <p>{formatDateTimeString(item.revokedAt)}</p>
          </div>
          <div className={`${styles.cell} ${styles.actionCell}`}>
            {!revoked &&
              <FontAwesomeIcon
                className={styles.button}
                icon={faBan}
                color={Colors.euro_600}
                title='Revoke'
                onClick={() => onRevokeClick && onRevokeClick(item)}
              />
            }
          </div>
        </Card>
      )
    })
  }

  return (
    <div>
      {renderHeader()}
      {credentials.length > 0 && renderListItems()}
      {credentials.length === 0 && <p>No signing credentials configured</p>}
    </div>
  )
}

export default IntegrationSigningCredentialList

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    padding: '3px 3px',
    margin: '5px 0',
    transition: '0.4s',
    '&:hover': {
      backgroundColor: Colors.darkGrayHover,
    }
  },
  header: {
    margin: '10px 0 5px 0',
  },
  '& p': {
    fontSize: 12,
    margin: 0,
    wordBreak: 'break-word',
    '& span': {
      fontFamily: 'Aestetico-Bold',
      color: Colors.euro_600,
    }
  },
  cell: {
    flex: 1,
    padding: '0px 5px'
  },
  thumbprintCell: {
    flex: '1 1 180px',
    padding: '0px 5px'
  },
  actionCell: {
    textAlign: 'center',
    flex: '0 0 40px'
  },
  button: {
    transition: '0.4s',
    '&:hover': {
      color: Colors.euro5,
      cursor: 'pointer',
    }
  },
})
